/**
 * RunwayDivider — a thin gold streak that animates left-to-right between sections.
 * Pure CSS, no JS, accessible (decorative only).
 */
const RunwayDivider = ({ className = "" }) => (
  <div
    className={`runway-divider ${className}`}
    role="presentation"
    aria-hidden="true"
    data-testid="runway-divider"
  />
);

export default RunwayDivider;
